module.exports = function (fox) {
	'use strict';

	require('./stylus/_style.styl');

	var require__template = require.context('fox-dynamic-injection!fox-template-loader!./templates', true, /\.tpl$/);

	require__template.keys().forEach(function (module) {
		require__template(module)(fox);
	});

	// var require__js = require.context('./widget', true, /\.js$/);

	// require__js.keys().forEach(function (module) {
	// 	require__js(module)(fox);
	// });
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/ccpa/index.es.js